<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog :title="title" :visible.sync="show" width="30%">
			<el-form ref="form" :model="form" label-width="100px">
				<el-form-item label="品牌名称">
					<el-input :disabled="title[0] == '查'" v-model="form.name" placeholder="请输入品牌名称"></el-input>
				</el-form-item>
				<el-form-item label="品牌信息">
					<el-input :disabled="title[0] == '查'" v-model="form.info" placeholder="请输入品牌信息"></el-input>
				</el-form-item>
				<el-form-item label="品牌类别">
					<el-select :disabled="title[0] == '查'" style="width:100%" v-model="form.type" placeholder="请选择类别">
						<el-option v-for="item in typeList" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="title[0] != '查'">
					<el-button @click="addUser" style="margin-left:30px;" type="primary" size="mini">添加联系人</el-button>
					<el-button v-if="userList.length > 1" @click="delUser" style="margin-left:10px;" type="primary"
						size="mini">减少联系人</el-button>
				</el-form-item>
				<div v-for="(item, index) in userList" :key="index">
					<el-form-item :label="'品牌联系人' + (index + 1)">
						<el-input :disabled="title[0] == '查'" v-model="item.contacts"></el-input>
					</el-form-item>
					<el-form-item label="联系电话">
						<el-input :disabled="title[0] == '查'" v-model="item.phone"
							@input="(v) => (form.phone = v.replace(/[^\d-]/g, ''))"></el-input>
					</el-form-item>
				</div>

				<el-form-item label="品牌描述">
					<el-input :disabled="title[0] == '查'" v-model="form.describe" placeholder="请输入品牌描述"></el-input>
				</el-form-item>
				<el-form-item label="资料上传" v-if="title[0] != '查'">
					<el-upload ref="uploadFile" class="upload-demo" action="/api/admin/dutyInfo/uploadFile" name="file"
						:before-upload="beforeUpload" :file-list="fileList" :headers="headerData"
						:on-success="onSuccess" :on-remove="fileRemove">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
					<!-- :show-file-list="false"
					<div v-for="(item, index) in fileList" :key="index"
						style="color: #3C98FF;cursor: pointer;display: flex;justify-content: space-between;">
						<div @click="down(item.name, item.url)">{{ item.name }}</div>
						<div @click="delUrl(index)"><i class="el-icon-delete"></i></div>
					</div> -->
				</el-form-item>
				<el-form-item label="附件下载" v-if="title[0] == '查' && form.fileName != null">
					<div @click="down(item.name, item.url)" v-for="item in fileList"
						style="color: #3C98FF;cursor: pointer;">
						{{ item.name }}
					</div>
				</el-form-item>
				<el-form-item v-if="form.status == '未通过'" label="拒绝原因">
					<el-input :disabled="title[0] == '查'" v-model="form.reason"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button v-if="title[0] != '查'" type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<el-form :inline="true" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="品牌名称">
						<el-input size="small"  v-model="selectForm.name" placeholder="品牌名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="类别">
						<el-select size="small"  v-model="selectForm.type" placeholder="类别" clearable>
							<el-option label="全部" :value="``"></el-option>
							<el-option v-for="item in typeList" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="联系人">
						<el-input size="small"  v-model="selectForm.contacts" placeholder="联系人" clearable></el-input>
					</el-form-item>
					<el-form-item label="联系电话">

						<el-input size="small"  v-model="selectForm.phone" placeholder="联系电话" clearable></el-input>
					</el-form-item>
					<!-- <el-form-item label="审核状态">
						<el-select v-model="selectForm.status" placeholder="审核状态">
							<el-option label="全部" :value="``"></el-option>
							<el-option label="已通过" value="已通过"></el-option>
							<el-option label="待审核" value="待审核"></el-option>
							<el-option label="已拒绝" value="已拒绝"></el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item>
						<el-button size="small"  type="primary" @click="getAll()">查询</el-button>
						<el-button size="small"  type="primary" @click="addRow()">新增</el-button>
						<el-button size="small"  type="primary" @click="dc()">导出</el-button>
					</el-form-item>
				</div>
				<div>

				</div>
			</div>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="name" label="品牌名称"></el-table-column>
			<el-table-column prop="info" label="品牌信息"></el-table-column>
			<el-table-column prop="type" label="类别"></el-table-column>
			<el-table-column prop="describes" label="品牌描述"></el-table-column>
			<el-table-column prop="contacts" label="品牌方联系人"></el-table-column>
			<el-table-column prop="phone" label="联系电话"></el-table-column>
			<!-- <el-table-column prop="status" label="审核状态"></el-table-column> -->
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="setRow(row, '1')">详情</el-button>
					<el-button type="text" @click="setRow(row, '2')">编辑</el-button>
					<el-button type="text" @click="movRow(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination v-if="count > 0" :page-sizes="[10, 20, 30, 50]" :page-size="selectForm.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
			@current-change="handleCurrentChange">
		</el-pagination>
	</div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
import downloadFile from '../../assets/js/downloadFile.js';
export default {
	data() {
		return {
			userList: [{
				contacts: "",
				phone: ""
			}],
			fileNameList: [],
			filePathList: [],
			typeList: [
				{
					label: "零售",
					value: "零售"
				},
				{
					label: "娱乐",
					value: "娱乐"
				},
				{
					label: "餐饮",
					value: "餐饮"
				},
				{
					label: "其他",
					value: "其他"
				},
			],
			headerData: {
				Authorization: localStorage.access_token
			},
			title: "新增",
			count: 0,
			show: false,
			selectForm: {
				name: "", //品牌方名称
				type: "",
				contacts: "", //联系人 
				phone: "", //联系电话 
				status: "", //状态 
				currentPage: 1,
				pageSize: 10,
			},
			fileList: [],
			oldForm: "",
			form: {
				"name": "",
				info: "",
				type: "",
				contacts: "",
				phone: "",
				describe: "",

				filePath: null, fileName: null
			},
			data: []
		}
	},
	methods: {
		addUser() {
			this.userList.push({
				contacts: "",
				phone: ""
			})
		},
		delUser() {
			this.userList.splice(this.userList.length - 1, 1);
		},
		down(name, url) {
			let a = document.createElement('a')
			a.href = url;
			a.click();
			// downloadFile(url)
		},
		delUrl(index) {
			this.fileNameList.splice(index, 1)
			this.filePathList.splice(index, 1)
			this.fileList.splice(index, 1)
		},
		movRow(obj) {
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.delete(`/api/investmentManagement/deleteInvestmentManagement?id=${obj.id}`).then(
					res => {
						if (res.data.code == 0) {
							this.$message.success("删除成功")
							this.getAll()
						} else {
							this.$message.error("删除失败")
						}
					})
			}).catch(() => { });
		},
		beforeUpload(file, fileList) {
			// console.log(file.name.split(".")[0])
			// console.log(this.fileList)
			let status = true;
			this.fileNameList.forEach(element => {
				if (file.name.split(".")[0] == element) {
					status = false;
				}
			});
			if (!status) {
				this.$message.error(`${file.name.split(".")[0]}文件已存在！`)

			}
			return status;
		},
		onSuccess(response, file, fileList) {
			// this.detailFileList(fileList);
			if (response.code == '0') {
				// this.form.filePath = fileList[0].response.data.filePath;
				// this.form.fileName = fileList[0].response.data.fileName;
				this.fileNameList.push(file.name.split(".")[0])
				this.filePathList.push(response.data)
				this.fileList.push({ name: file.name.split(".")[0], url: response.data, uid: file.uid })
				// this.form.files = [res.data]
				this.$message.success("上传成功")
			} else {
				this.$message.error("上传失败")

				//上传失败不显示列表文件
				let uid = file.uid;
				this.clearShowList(uid)
				this.clearFileList(uid)
			}
		},
		// 删除临时文件
		fileRemove(file) {
			this.clearFileList(file.uid)
		},
		//下面两个方法是重点
		//清空文件列表
		clearFileList(uid) {
			let fileListIdx = this.fileList.findIndex(item => item.uid === uid)
			this.fileList.splice(fileListIdx, 1)
		},
		//清空显示列表
		clearShowList(uid) {
			let idx = this.$refs['uploadFile'].uploadFiles.findIndex(item => item.uid === uid)
			this.$refs.uploadFile.uploadFiles.splice(idx, 1)
		},
		setRow(obj, type) {
			if (type == 1) {
				this.title = "查看"
			} else {
				this.title = "编辑"
			}


			this.form = {
				...obj
			}
			let newFiles = [];
			this.fileNameList = [];
			this.filePathList = [];
			if (this.form.fileName) {
				let fileNameList = this.form.fileName;
				let filePathList = this.form.filePath;
				this.fileNameList = fileNameList.split(",");
				this.filePathList = filePathList.split(",");
				this.fileNameList.forEach((element, index) => {
					newFiles.push({
						name: element,
						url: this.filePathList[index]
					});
				});
			}
			this.fileList = newFiles

			this.userList = [];
			let contactsList = []
			let phoneList = []
			if (this.form.contacts) {
				contactsList = this.form.contacts.split(",");
				phoneList = (this.form.phone.toString()).split(",");
				contactsList.forEach((element, index) => {
					this.userList.push({
						contacts: element,
						phone: phoneList[index]
					})
				});
			} else {
				this.userList.push({
					contacts: "",
					phone: ""
				})
			}
			this.show = true
		},
		dc() {
			publicExport("/api/investmentManagement/export", this.selectForm, "招商管理")
		},
		ok() {
			let url = "/api/investmentManagement/addInvestmentManagement"
			if (this.title == "编辑") {
				url = "/api/investmentManagement/editInvestmentManagement"
			}
			var a = new Date().getTime()
			this.form.createTime = a

			this.form.fileName = this.fileNameList.toString();
			this.form.filePath = this.filePathList.toString();

			let contactsList = [];
			let phoneList = [];
			this.userList.forEach(element => {
				contactsList.push(element.contacts)
				phoneList.push(element.phone.toString())
			});
			this.form.contacts = contactsList.toString();
			this.form.phone = phoneList.toString();
			this.$http.post(url, this.form).then(res => {
				if (res.data.code == 0) {
					this.getAll()
					if (this.title == "新增") {
						this.$http.post(`/api/oa/attract/newProcess`, res.data.data)
					}
					this.show = false
					this.$message.success(`${this.title}成功`)
				} else {
					this.$message.error(`${this.title}失败`)
				}
			})
		},
		addRow() {
			this.form = JSON.parse(JSON.stringify(this.oldForm))
			this.title = "新增"
			this.fileList = []
			this.fileNameList = []
			this.filePathList = []
			this.userList = [];
			this.show = true;
		},
		getAll() {
			this.$http.post("/api/investmentManagement/findInvestmentManagement", this.selectForm).then(res => {
				this.data = res.data.data.items
				this.count = res.data.data.totalNum
			})
		},
		handleClick() {
			this.getAll()
		},
		handleCurrentChange(val) {
			this.selectForm.currentPage = val;
			this.getAll()
		},
		handleSizeChange(val) {
			this.selectForm.pageSize = val;
			this.getAll()
		},
	},
	created() {
		this.oldForm = JSON.parse(JSON.stringify(this.form))
		this.getAll();
	}
}
</script>

<style scoped="scoped">

</style>
